/**
 * De foutcode van een httpsCallable zonder voorvoegsel 'functions/'.
 *
 * De functies-SDK geeft de code soms als 'functions/permission-denied' en soms
 * kaal; elke afnemer toetst op de kale vorm. Eén plek, zodat een tweede
 * afnemer niet een eigen variant schrijft die net anders omgaat met een lege code.
 *
 * @param {string | undefined | null} code - `error.code` uit een httpsCallable
 * @returns {string | undefined | null} De kale code; geen string → ongewijzigd
 */
const normalizeCallableCode = (code) => (typeof code === 'string'
    ? code.replace(/^functions\//, '')
    : code)

export default normalizeCallableCode
